import { ReactNode } from "react";
import { useGetABOProfileQuery } from "../../../services/AboProfile/AboProfileAPI";
type Props = {
  affAbo: string;
  children: ReactNode;
};

const CustomerProfileDataLayer = ({ affAbo, children }: Props) => {
  const [aff = "", abo = ""] = (affAbo ?? "").split("-");
  useGetABOProfileQuery({ aff, abo }, { skip: !aff || !abo });

  return <>{children}</>;
};

export default CustomerProfileDataLayer;
